/* Sternkerze — Geschenkbox-Konfigurator (Happy New Year Box).
   15 Mini-Sternkerzen frei waehlen: Klick auf eine Farbe zaehlt hoch,
   die Box-Vorschau (15 Stern-Plaetze) fuellt sich mit, ein Klick auf
   einen gefuellten Stern nimmt die Kerze wieder heraus. Eine feste
   Leiste am unteren Rand zeigt Stand und Total, sobald Vorschau und
   Fussleiste aus dem Bild gescrollt sind. Der Kauf legt die Schachtel
   plus alle Kerzen als eigene Positionen in den Warenkorb — so stimmt
   der Lagerbestand automatisch. */
(function () {
  function geld(rappen) {
    return 'CHF ' + (rappen / 100).toFixed(2).replace(/\.00$/, '.–');
  }

  function einrichten(wurzel) {
    var ziel = parseInt(wurzel.dataset.ziel, 10) || 15;
    var boxVariante = parseInt(wurzel.dataset.boxVariante, 10);
    var boxPreis = parseInt(wurzel.dataset.boxPreis, 10) || 0;
    var kurzname = wurzel.dataset.kurzname || 'Geschenkbox';

    var leiste = document.querySelector('[data-sk-box-leiste]');
    var slots = wurzel.querySelectorAll('[data-sk-slot]');
    var anzahlElemente = [].slice.call(wurzel.querySelectorAll('[data-sk-box-anzahl]'));
    var totalElemente = [].slice.call(wurzel.querySelectorAll('[data-sk-box-total]'));
    var kaufKnoepfe = [].slice.call(wurzel.querySelectorAll('[data-sk-box-kaufen]'));
    if (leiste) {
      anzahlElemente = anzahlElemente.concat([].slice.call(leiste.querySelectorAll('[data-sk-box-anzahl]')));
      totalElemente = totalElemente.concat([].slice.call(leiste.querySelectorAll('[data-sk-box-total]')));
      kaufKnoepfe = kaufKnoepfe.concat([].slice.call(leiste.querySelectorAll('[data-sk-box-kaufen]')));
    }
    var fehler = wurzel.querySelector('[data-sk-box-fehler]');

    /* Map behaelt die Reihenfolge, in der Farben gewaehlt wurden. */
    var auswahl = new Map();

    function anzahlTotal() {
      var n = 0;
      auswahl.forEach(function (e) { n += e.anzahl; });
      return n;
    }

    function meldung(text) {
      if (!fehler) return;
      fehler.textContent = text || '';
      fehler.hidden = !text;
      if (text) fehler.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    }

    function zeichnen() {
      var n = anzahlTotal();
      var summe = boxPreis;
      var einheiten = [];
      auswahl.forEach(function (e, id) {
        summe += e.preis * e.anzahl;
        for (var i = 0; i < e.anzahl; i++) einheiten.push({ id: id, farbe: e.farbe, hex: e.hex });
      });

      anzahlElemente.forEach(function (el) { el.textContent = n; });
      totalElemente.forEach(function (el) { el.textContent = geld(summe); });

      /* Box-Vorschau: Stern-Plaetze fuellen */
      slots.forEach(function (slot, i) {
        var stern = slot.querySelector('.sk-box__stern');
        var einheit = einheiten[i];
        if (einheit) {
          stern.style.background = einheit.hex;
          slot.disabled = false;
          slot.dataset.variante = einheit.id;
          slot.classList.add('sk-box__slot--voll');
          slot.setAttribute('aria-label', 'Eine Kerze ' + einheit.farbe + ' entfernen');
        } else {
          stern.style.background = '';
          slot.disabled = true;
          delete slot.dataset.variante;
          slot.classList.remove('sk-box__slot--voll');
          slot.setAttribute('aria-label', 'Platz ' + (i + 1) + ' von ' + ziel + ' – leer');
        }
      });

      /* Mengen-Badges auf den Farbkacheln */
      wurzel.querySelectorAll('[data-sk-kerze]').forEach(function (k) {
        var e = auswahl.get(k.dataset.variante);
        var badge = k.querySelector('[data-sk-menge]');
        if (e && e.anzahl > 0) {
          badge.textContent = e.anzahl;
          badge.hidden = false;
          k.classList.add('sk-box__kerze--an');
        } else {
          badge.hidden = true;
          k.classList.remove('sk-box__kerze--an');
        }
      });

      /* Kaufknoepfe (Stand, Fuss und Leiste) */
      kaufKnoepfe.forEach(function (knopf) {
        if (n < ziel) {
          var rest = ziel - n;
          knopf.disabled = true;
          knopf.textContent = 'Noch ' + rest + (rest === 1 ? ' Kerze' : ' Kerzen') + ' wählen';
        } else {
          knopf.disabled = false;
          knopf.textContent = 'In den Warenkorb legen – ' + geld(summe);
        }
      });
    }

    wurzel.addEventListener('click', function (e) {
      var kachel = e.target.closest('[data-sk-kerze]');
      if (kachel && !kachel.disabled) {
        if (anzahlTotal() >= ziel) {
          meldung('Deine Box ist voll (' + ziel + ' Kerzen) – nimm in der Vorschau zuerst eine heraus.');
          return;
        }
        meldung('');
        var id = kachel.dataset.variante;
        var eintrag = auswahl.get(id);
        if (!eintrag) {
          eintrag = {
            farbe: kachel.dataset.farbe,
            preis: parseInt(kachel.dataset.preis, 10) || 0,
            hex: kachel.dataset.hex || '#EDE9DE',
            anzahl: 0
          };
          auswahl.set(id, eintrag);
        }
        eintrag.anzahl += 1;
        zeichnen();
        return;
      }

      var slot = e.target.closest('[data-sk-slot]');
      if (slot && slot.dataset.variante) {
        meldung('');
        var sid = slot.dataset.variante;
        var se = auswahl.get(sid);
        if (se) {
          se.anzahl -= 1;
          if (se.anzahl <= 0) auswahl.delete(sid);
        }
        zeichnen();
      }
    });

    function kaufen() {
      if (anzahlTotal() < ziel) return;
      kaufKnoepfe.forEach(function (k) { k.disabled = true; k.textContent = 'Wird in den Warenkorb gelegt …'; });
      meldung('');

      var posten = [];
      auswahl.forEach(function (e, id) {
        posten.push({
          id: parseInt(id, 10),
          quantity: e.anzahl,
          properties: { 'Geschenkbox': kurzname }
        });
      });
      posten.push({
        id: boxVariante,
        quantity: 1,
        properties: { 'Inhalt': ziel + ' Mini-Sternkerzen nach Wahl' }
      });

      fetch(((window.theme && theme.routes.cart_add_url) || '/cart/add') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: posten })
      }).then(function (antwort) {
        if (antwort.ok) {
          window.location.href = (window.theme && theme.routes.cart_url) || '/cart';
          return null;
        }
        return antwort.json();
      }).then(function (daten) {
        if (!daten) return;
        meldung(daten.description || daten.message || 'Das hat leider nicht geklappt – versuch es nochmals.');
        zeichnen();
      }).catch(function () {
        meldung('Keine Verbindung – versuch es gleich nochmals.');
        zeichnen();
      });
    }

    kaufKnoepfe.forEach(function (k) { k.addEventListener('click', kaufen); });

    /* Feste Leiste nur zeigen, wenn weder Stand noch Fussleiste im Bild sind. */
    if (leiste) {
      var stand = wurzel.querySelector('.sk-box__stand');
      var fuss = wurzel.querySelector('[data-sk-box-fuss]');
      if ('IntersectionObserver' in window && (stand || fuss)) {
        var sichtbar = new Set();
        var beobachter = new IntersectionObserver(function (eintraege) {
          eintraege.forEach(function (e) {
            if (e.isIntersecting) sichtbar.add(e.target);
            else sichtbar.delete(e.target);
          });
          leiste.hidden = sichtbar.size > 0;
        }, { rootMargin: '0px 0px -56px 0px' });
        if (stand) beobachter.observe(stand);
        if (fuss) beobachter.observe(fuss);
      } else {
        leiste.hidden = false;
      }
    }

    zeichnen();
  }

  function start() {
    document.querySelectorAll('[data-sk-box]').forEach(einrichten);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
